import { useEffect, useState, type MouseEvent } from "react";

export interface TocHeading {
  id: string;
  text: string;
}

interface ArticleTocProps {
  headings: TocHeading[];
}

export default function ArticleToc({ headings }: ArticleTocProps) {
  const [active, setActive] = useState(headings[0]?.id ?? "");
  const key = headings.map((item) => item.id).join("|");

  useEffect(() => {
    const handler = () => {
      let current = headings[0]?.id ?? "";
      headings.forEach((item) => {
        const el = document.getElementById(item.id);
        if (el && el.getBoundingClientRect().top <= 140) {
          current = item.id;
        }
      });
      setActive(current);
    };
    handler();
    window.addEventListener("scroll", handler, { passive: true });
    return () => window.removeEventListener("scroll", handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  if (headings.length === 0) return null;

  const handleClick = (event: MouseEvent<HTMLAnchorElement>, id: string) => {
    event.preventDefault();
    const el = document.getElementById(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 96;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <nav aria-label="文章目录" className="rounded-lg bg-background-100 border border-background-200 p-5 md:p-6">
      <h2 className="flex items-center gap-2 text-sm font-semibold text-foreground-950 pb-3 border-b border-background-200">
        <i className="ri-list-check-2 text-primary-600"></i>
        阅读目录
      </h2>
      <ul className="mt-3 space-y-1">
        {headings.map((item) => (
          <li key={item.id}>
            <a
              href={`#${item.id}`}
              onClick={(event) => handleClick(event, item.id)}
              className={`block py-1.5 pl-3 border-l-2 text-sm leading-snug transition-colors ${
                active === item.id
                  ? "border-primary-500 text-primary-700 font-medium"
                  : "border-transparent text-foreground-600 hover:text-foreground-950"
              }`}
            >
              {item.text}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}